import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { googleRequest, googleError } from '../lib/directGoogle';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

export default function SocialContinue() {
  const { user, loginUser } = useAuth();
  const navigate = useNavigate();
  const [flow, setFlow] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [password, setPassword] = useState('');
  const [reauth, setReauth] = useState(false);
  useEffect(() => {
    let alive = true;
    googleRequest('/google/flow', undefined, 'GET').then(r => { if (alive) setFlow(r); }).catch(e => { if (alive) setError(googleError(e)); });
    return () => { alive = false; };
  }, []);
  async function act(kind) {
    if (busy) return;
    setBusy(true); setError('');
    try {
      if (kind === 'attach' && reauth) await googleRequest('/google/reauth', { password });
      const result = await googleRequest(`/google/${kind}`, kind === 'attach' ? { expected_user_id: user.id } : undefined);
      if (result.access_token) {
        await loginUser(result.access_token, result.user);
        if (localStorage.getItem('token') !== result.access_token) throw new Error('Session changed');
      }
      navigate(result.next || '/', { replace: true });
    } catch (e) {
      if (e?.response?.data?.detail?.code === 'reauth_required') setReauth(true);
      setError(googleError(e));
    } finally { setBusy(false); }
  }
  const signIn = () => navigate('/login?next=%2Fauth%2Fcontinue', { replace: true });
  return <main className="min-h-screen flex items-center justify-center bg-background text-foreground p-6">
    <section className="w-full max-w-md rounded-xl border border-border bg-card p-6 space-y-4">
      <h1 className="text-xl font-semibold">Koppla ditt Google-konto</h1>
      {error && <p role="alert" className="text-sm text-red-500">{error}</p>}
      {flow && <>
        <p className="text-sm text-muted-foreground">{flow.email || flow.name || 'Google-kontot'} används för inloggning.</p>
        {user ? <>
          <p className="text-sm">Koppla till ditt Trainnova-konto: <strong>{user.name || user.email}</strong>.</p>
          {reauth && <Input type="password" autoComplete="current-password" placeholder="Ditt Trainnova-lösenord" value={password} onChange={e => setPassword(e.target.value)} />}
          <Button className="w-full" disabled={busy} onClick={() => act('attach')}>{busy ? 'Arbetar…' : 'Bekräfta koppling'}</Button>
          {reauth && <Button variant="outline" className="w-full" onClick={signIn}>Verifiera med inloggningslänk</Button>}
        </> : <>
          <Button variant="outline" className="w-full" onClick={signIn}>Jag har redan ett konto</Button>
          {flow.mode === 'auth' && <Button className="w-full" disabled={busy} onClick={() => act('register')}>Skapa nytt konto</Button>}
          <p className="text-xs text-muted-foreground">Har du använt Trainnova tidigare? Logga in på ditt befintliga konto för att behålla historiken. Efter inloggning via mejl kan du återvända hit och ladda om sidan.</p>
        </>}
      </>}
      <Button variant="ghost" className="w-full" disabled={busy} onClick={async () => {
        try { await googleRequest('/google/cancel'); } catch { /* expired flow */ }
        navigate(flow?.mode === 'link' ? '/settings' : '/login', { replace: true });
      }}>Avbryt</Button>
    </section></main>;
}
